<template>
  <vf-header>
    <template
      v-if="$feature.tempShowCartCtaOnMobileNav"
      #cart="{ cart, cartLabel, header }"
    >
      <template v-if="cart?.totalItems">
        <div v-if="!header.expanded" class="mx-1 b-l -my-3 lg:hidden" style="border-color: #D9D9D9; height: 3.375rem" />
        <base-link
          :aria-label="cartLabel"
          class="group hidden"
          :class="{ '<lg:block': !header.expanded }"
          style="border-color: #D9D9D9"
          to="/cart"
          @click="$gtm.push('topNav.onClickUtilityLink', 'Cart')"
        >
          <span class="relative block rounded-sm p-2.5 duration">
            <vf-icon name="bag" size="md" />
            <span
              v-if="cart?.totalItems"
              aria-hidden="true"
              class="absolute right-0 top-0 m-2 h-3 w-3 flex select-none center rounded-full bg-brand-3 text-micro c-white lh-none ring ring-white"
            >
              {{ cart.totalItems }}
            </span>
          </span>
        </base-link>
      </template>
    </template>
  </vf-header>
</template>

<script lang="ts" setup>
import VfHeader from '#brand/components/vf/header/Header.vue'

const { $feature } = useNuxtApp()

const config = useAppConfig().components.vf.header

if ($feature.tempShowCartCtaOnMobileNav) {
  config.brandClasses.floatingNavigation = `
    flex center p-1 ease-out duration 
    lg:grid lg:cols-[1fr_auto_1fr] lg:w-full lg:px-3 lg:py-2 
    <lg:b <lg:rounded-$rounded <lg:bg-brand-2 <lg:op-$op <lg:shadow-$shadow <lg:backdrop-blur
    `
  config.brandClasses.floatingNavigationExpanded = 'grow <lg:gap-5'
  config.showMenuIndicator = false
}
</script>
